import Vue from 'vue';
import App from './App.vue';
import store from './store';
import i18n from './i18n'
import getRouter from './router'
import BaseUI from '@zkwq/business'
import '@zkwq/business/dist/index.min.css'
import {BaseUtil} from '@zkwq/business'
import zhLocale from '@zkwq/business/dist/locale/lang/zh-CN' 
import enLocale from '@zkwq/business/dist/locale/lang/en' 
import ruLocale from '@zkwq/business/dist/locale/lang/ru-RU' 
import AppMixin from '@/mixins/index'
let locale = BaseUtil.getStorage('app_locale') || 'zh'
Vue.use(BaseUI,{
  locale:locale == 'zh'?zhLocale:locale == 'en'?enLocale:locale == 'ru'?ruLocale:zhLocale
})
Vue.mixin(AppMixin)
Vue.config.productionTip = false;
import Pagination from "@/components/Pagination";
Vue.component('PaginationMain', Pagination)
// import Fingerprint2 from 'fingerprintjs2'
import loading from "@/components/index";
import {guid} from "@/utils/index";
Vue.component('loadingMain', loading)
getRouter(store).then(router => {
  router.beforeEach((to, from, next) => {
    if (!store.state.user) {
      let visitorId = BaseUtil.getStorage('temp_user_id')
      if(!visitorId){
        visitorId = guid()
        BaseUtil.setStorage('temp_user_id',visitorId,-1)
      }
      let administrator = {
        "affiliation":["匿名机构"],
        "uid":visitorId,
        "name":"匿名用户",
        "anonymous":true
      }
      administrator.id = administrator.uid
      store.state.user = administrator
      // const fp = new Fingerprint2.get((result) => {
      //   const values = result.map(component => component.value); // 配置的值的数组
      //   const id = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
      //   console.log(id)
      //   let anonymousUser = {
      //     id: id,
      //     uid:  id,
      //     affiliation:  ['机构_' + BaseUtil.randomString(10)],
      //     name: '用户_'+ BaseUtil.randomString(10),
      //     anonymous: true
      //   }
      //   store.state.user = anonymousUser
      // })
    }
    next();
  })
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})

